module.exports = __webpack_public_path__ + "img/SeaofBlueTears.2074aa7f.png";